import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useProducts, useCategories } from "@/lib/api";
import { slugifyTr } from "@/lib/slugify";
import Seo from "@/components/common/Seo";
import SectionHeading from "@/components/common/SectionHeading";
import ProductCard from "@/components/products/ProductCard";
import NotFound from "@/components/common/NotFound";

const SITE = process.env.REACT_APP_SITE_URL;

export default function Category() {
  const { slug } = useParams();
  const { data: products = [] } = useProducts();
  const { data: categories = [], isLoading } = useCategories();

  const category = useMemo(
    () => categories.find((c) => slugifyTr(c.name) === slug),
    [categories, slug]
  );

  // Kategoriler yüklendi ama eşleşme yoksa → gerçek 404
  if (!isLoading && categories.length > 0 && !category) return <NotFound />;

  const items = products.filter((p) => p.category === category?.name);
  const title = category?.name || "Kategori";
  const origin = SITE || (typeof window !== "undefined" ? window.location.origin : "");

  return (
    <div data-testid="category-page" className="bg-cream">
      <Seo
        title={title}
        description={
          category?.description ||
          `${title} kategorisindeki günlük taze kesim ürünler. Lezzet, yumuşaklık ve pişirme notlarıyla. WhatsApp ile kolay sipariş.`
        }
        jsonLd={
          items.length
            ? {
                "@context": "https://schema.org",
                "@type": "ItemList",
                name: `Ertan Kasap · ${title}`,
                numberOfItems: items.length,
                itemListElement: items.map((p, i) => ({
                  "@type": "ListItem",
                  position: i + 1,
                  url: origin + "/urun/" + p.slug,
                  name: p.name,
                })),
              }
            : undefined
        }
      />
      <section className="border-b border-dashed border-bordo/30 pt-16 pb-12">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <SectionHeading
            as="h1"
            eyebrow="Kategori"
            title={title}
            description={category?.description || `${title} kategorisindeki özenle seçilmiş ürünler.`}
          />
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <p className="mb-6 font-mono text-xs uppercase tracking-wider text-charcoal/50" data-testid="category-count">
          {items.length} ürün
        </p>
        {items.length === 0 ? (
          <div className="border border-dashed border-bordo/30 py-20 text-center font-mono text-sm text-charcoal/50">
            Bu kategoride ürün bulunamadı.
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {items.map((p) => (
              <ProductCard key={p.slug} product={p} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
